import moment from 'moment';
import React, { Fragment, useEffect, useState, useRef } from 'react'
import { formatNumber } from '../../../Utils/Money';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';
import DataReactTableAccountStatus from './DataReactTableAccountStatus';
import SummaryInfoStatusAccount from './SummaryInfoStatusAccount';
import ShowSettlementCard from '../../../SettlementSupport/Components/ShowSettlementCard';
import DataReactTableBalanceAccount from './DataReactTableBalanceAccount';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import pdfStatusAccount from './pdfStatusAccount';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import MomentUtils from '@date-io/moment';
import { DatePicker, KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DataReactTableReceiptsThird from '../../../ThirdParties/components/DisplayThridInformation/components/receiptsFromThird/DataReactTableReceiptsThird';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});

const ProfileAccountStatus = ({ id_historia, id_tercero }) => {
    const [invoicesData, setInvoicesData] = useState(null);
    const [profileType, setProfileType] = useState('');
    const [load, setLoad] = useState(true);
    const [invoiceSettlement, setInvoiceSettlement] = useState(null);
    const [displayInvoiceSettlement, setDisplayInvoiceSettlement] = useState(false);
    const [abonosFromPatient, setAbonosFromPatient] = useState(null); //Todos los abonos que ha pagado el paciente (Particulares y de otros regímenes)
    const [showStatusAccountPdf, setShowStatusAccountPdf] = useState(false);
    const [datesStatusAccount, setDatesStatusAccount] = useState({ startDate: null, endDate: null });
    const [dataPatient, setDataPatient] = useState(null);
    const [mountTotalStatusAccount, setMountTotalStatusAccount] = useState(null); // totales del array invoicesData
    const [advancedPayments, setAdvancedPayments] = useState(null); //Anticipos
    const urlLogo = sessionStorage.getItem('logoURL');
    const profile = JSON.parse(sessionStorage.getItem('clinica'));


    //Balance
    const [balanceData, setBalanceData] = useState(null);
    const [createReportByCostum, setCreateReportByCostum] = useState(false);
    const [balanceModifiedByRange, setBalanceModifiedByRange] = useState(null);
    const [recalculateBalanceValuesByRangeSelected, setRecalculateBalanceValuesByRangeSelected] = useState(null);
    const [allRetentionsRange, setAllRetentionsRange] = useState(null);
    const [loadBalance, setLoadBalance] = useState(false);
    const [receiptsByInvoice, setReceiptsByInvoice] = useState(null);
    const [loadReceipts, setLoadReceipts] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [showModalDetails, setShowModalDetails] = useState(false);
    const skipPageResetRef = useRef();


    useEffect(() => {
        skipPageResetRef.current = false
        if (id_tercero !== null && id_tercero !== undefined) {
            setProfileType('client');
            checkInvoicesThird();
        } else {
            setProfileType('patient');
            checkInvoicesPatient();
        }
    }, [])

    useEffect(() => {
        if (datesStatusAccount.startDate !== null && datesStatusAccount.endDate !== null) {
            skipPageResetRef.current = false
            setNewRange();
        }
    }, [datesStatusAccount])



    const checkInvoicesPatient = async () => {
        setLoad(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/revisar-facturas-paciente?id_historia=' + id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("FACTURAST", data);
                if (data?.facturas.length > 0) {
                    //setInvoicesData(data.facturas);
                    filterParticularInvoices(data.facturas);
                    defineIdentyPacient(data.facturas);
                }
                else {
                    setInvoicesData(null);
                }
                setLoad(false);
            })
            .catch((error) => {
                setLoad(false);
                console.error('Error:', error);
            });

    }

    const checkInvoicesThird = async () => {
        setLoad(true);
        setLoadBalance(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/revisar-facturas-paciente?id_tercero=' + id_tercero, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("FACTURAST", data);
                if (data?.facturas) {
                    //setInvoicesData(data.facturas);
                    filterInvoicesFromParticular(data.facturas)
                }
                else {
                    setInvoicesData(null);
                }
                setLoad(false);
            })
            .catch((error) => {
                setLoad(false);
                console.error('Error:', error);
            });

    }

    //Se obtienen los anticipos de tercero creados en SAC
    const getAdvancedPayments = id_tercero => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'anticipo/consultar-por-tercero?id_tercero=' + id_tercero, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log("FACTURAST", data);
                    if (data.length > 0) {
                        resolve(data);
                        //setAdvancedPayments(data);
                    }
                    else {
                        //setAdvancedPayments(null);
                        resolve(data);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })

    }

    const stateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return 'POR PAGAR';
            } else if (parseInt(stateInvoice) === 2) {
                return 'PAGADA PARCIALMENTE';
            } else if (parseInt(stateInvoice) === 3) {
                return 'PAGADA COMPLETAMENTE';
            } else if (parseInt(stateInvoice) === 4) {
                return 'RETRASADA';
            } else if (parseInt(stateInvoice) === 5) {
                return 'SOBREPAGO';
            }
        } else {
            return 'POR PAGAR';
        }
    }
    const colorStateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return '#0084CF';
            } else if (parseInt(stateInvoice) === 2) {
                return '#FFA600';
            } else if (parseInt(stateInvoice) === 3) {
                return '#48CF00';
            } else if (parseInt(stateInvoice) === 4) {
                return '#FF2D00';
            } else if (parseInt(stateInvoice) === 5) {
                return '#6B00CF';
            }
        } else {
            return '#0084CF';
        }
    }

    const defineIdentyPacient = (invoices) => {
        if (invoices !== null) {
            if (invoices[0].paciente !== null) {
                setDataPatient(invoices[0].paciente)
            }
        }
    }

    //filtra las facturas que son del tercero
    const filterInvoicesFromParticular = (wholeInvoices) => {
        let invoices = wholeInvoices.filter((invoice) => invoice.tipo !== 1);
        let invoicesRemoveDuplicates = removeDuplicates(invoices, 'id_factura_t');
        setInvoicesData(invoicesRemoveDuplicates);
        organizeDataToShowBalance(invoicesRemoveDuplicates);
    }

    const removeDuplicates = (originalArray, prop) => {
        var newArray = [];
        var lookupObject = {};

        for (var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }

    const organizeDataToShowBalance = async (invoices) => {
        let tablesDataToDisplay = [];
        let allRetentions = [];
        let advancedPayments = null;
        let recieptsByPatient = [];
        // Se buscan los anticipos pagados por tercero
        /* if (id_tercero !== null && id_tercero !== undefined) {
            advancedPayments = await getAdvancedPayments(id_tercero);
            setAdvancedPayments(advancedPayments);

            if (advancedPayments !== null && advancedPayments !== undefined) {
                advancedPayments.forEach((advancedPay) => {
                    advancedPay.fechaToFilter = advancedPay.fecha_creacion;
                    advancedPay.detalle = advancedPay.id_anticipo;
                    advancedPay.accBalance = 0;
                    tablesDataToDisplay.push(advancedPay);
                })
            }
        } */

        //Se buscan los recibos que el paciente haya pagado como particular
        if (id_historia !== null && id_historia !== undefined) {
            let paymentsByPatientAbono = await loadReceipstFromPatient();

            if (paymentsByPatientAbono.length) {
                paymentsByPatientAbono.filter((receipt) => receipt.tipo_pago === 'PARTICULAR' && receipt.estado === 2);
                paymentsByPatientAbono.forEach((receipt) => recieptsByPatient.push(receipt));
            }

            if (recieptsByPatient.length) {
                recieptsByPatient.forEach((receipt) => {
                    receipt.fechaToFilter = receipt.fecha;
                    receipt.detalle = receipt.num_recibo;
                    receipt.accBalance = 0;
                    tablesDataToDisplay.push(receipt);
                })
            }
        }

        //Colocar pagos, anticipo, facturas y abonos en el mismo nivel del arreglo
        if (invoices.length) {
            for (let i = 0; i < invoices.length; i++) {
                const invoice = invoices[i];
                //Informaciòn de la creación de la factura para mostrar en balance
                let total_to_pay = calculateTotal(invoice);
                invoice.fechaToFilter = invoice.fecha_emision;
                invoice.detalle = invoice.num_fac_ter;
                //invoice.accBalance = 0;
                invoice.importeBalance = total_to_pay?.total_tercero;
                tablesDataToDisplay.push(invoice);

                //Se Define los Abonos hechos a Facturas
                /* if (invoice.servicios !== null && invoice.servicios !== undefined) {
                    let searchInfoReceipt;
                    if (invoice.servicios.recibos_caja.length > 0) {
                        for (let k = 0; k < invoice.servicios.recibos_caja.length; k++) {
                            const receipt = invoice.servicios.recibos_caja[k];
                            searchInfoReceipt = await loadReceiptById(receipt.id);
                            if (searchInfoReceipt !== null && searchInfoReceipt !== undefined) {
                                searchInfoReceipt.detalle = searchInfoReceipt.num_recibo;
                                searchInfoReceipt.fechaToFilter = searchInfoReceipt.fecha;
                                searchInfoReceipt.importeBalance = parseInt(searchInfoReceipt.total);
                                searchInfoReceipt.accBalance = 0;
                                tablesDataToDisplay.push(searchInfoReceipt);
                            }
                        }
                    }
    
                } */

                //Informacación de los pagos (creados en SAC) a las facturas
                if (invoice.pagos.length > 0 && id_tercero !== null) {
                    let filterPaymentsFromRetentions = filterPayments(invoice.pagos);
                    let filterRetentionsFromPayments = filterRetentions(invoice.pagos);

                    //Establece las retenciones a la factura para mostrarlos en el balance
                    if (filterRetentionsFromPayments.length > 0) {
                        filterRetentionsFromPayments.forEach((retention) => {
                            allRetentions.push(retention);
                            if (retention.fecha_creacion !== null) {
                                retention.fechaToFilter = retention.fecha_creacion;
                            }
                        })
                    }
                    //Define los pagos que se van a mostrar en el balance
                    if (filterPaymentsFromRetentions.length > 0) {
                        filterPaymentsFromRetentions.forEach((pago) => {
                            pago.fechaToFilter = pago.fecha_pago;
                            pago.detalle = pago.id_pago;
                            pago.accBalance = 0;
                            tablesDataToDisplay.push(pago);
                        })
                    }
                }
            }
        }


        let organizedArray = organizeInvoices(tablesDataToDisplay);
        if (invoices.length) {
            if (organizedArray[0].hasOwnProperty('num_fac_ter')) {
                organizedArray[0].accBalance = organizedArray[0].importeBalance; // para la primera factura el acumulador es el total de la factura
            } else if (organizedArray[0].hasOwnProperty('num_recibo')) {
                organizedArray[0].accBalance = -(parseInt(organizedArray[0].total)); // si el primer evento es un recibo el acumulador del balance comienza negativo
            } else if (organizedArray[0].hasOwnProperty('id_anticipo')) {
                organizedArray[0].accBalance = -organizedArray[0].valor; //si el primer evento es un anticipo el acumulador del balance es el valor del anticipo
            }
        }

        console.log('organizedArray', organizedArray);
        //setBalanceData(organizedArray);
        let organizedRetentions = organizeInvoices(allRetentions);
        setAllRetentionsRange(organizedRetentions);
        createValuesBanlance(organizedArray);
    }

    const createValuesBanlance = (organizedArray) => {
        skipPageResetRef.current = false;
        for (let i = 0; i < organizedArray.length; i++) {
            //Aqui se define el acumulador actual: element.accBalance verificando el acumulador del siguiente elemento 
            const previous_element = organizedArray[i - 1];
            const element = organizedArray[i];
            const next_element = organizedArray[i + 1];

            if (element.hasOwnProperty('num_fac_ter')) { //Si es una factura
                if (typeof next_element !== 'undefined') { // si el elemento siguiente no es indefinido
                    if (next_element.hasOwnProperty('num_fac_ter')) {
                        //element.accBalance = next_element.accBalance + element.importeBalance;
                        next_element.accBalance = element.accBalance + next_element.importeBalance
                    } else if (next_element.hasOwnProperty('id_pago')) {
                        //element.accBalance = next_element.accBalance + element.importeBalance;
                        next_element.accBalance = element.accBalance - next_element.importe;
                    } else if (next_element.hasOwnProperty('id_recibo')) {
                        next_element.accBalance = element.accBalance - (parseInt(next_element.total));
                    } else if (next_element.hasOwnProperty('id_anticipo')) {
                        next_element.accBalance = element.accBalance - next_element.valor;
                    }
                }
            } else if (element.hasOwnProperty('id_pago')) { // si es un pago
                if (typeof next_element !== 'undefined') { // si el elemento siguiente no es indefinido
                    if (next_element.hasOwnProperty('num_fac_ter')) {
                        //element.accBalance = next_element.accBalance + element.importeBalance;
                        next_element.accBalance = element.accBalance + next_element.importeBalance
                    } else if (next_element.hasOwnProperty('id_pago')) {
                        //element.accBalance = next_element.accBalance + element.importeBalance;
                        next_element.accBalance = element.accBalance - next_element.importe;
                    } else if (next_element.hasOwnProperty('id_recibo')) {
                        next_element.accBalance = element.accBalance - (parseInt(next_element.total));
                    } else if (next_element.hasOwnProperty('id_anticipo')) {
                        next_element.accBalance = element.accBalance - next_element.valor;
                    }
                }
            } else if (element.hasOwnProperty('num_recibo')) { // si es abono pagado a través de un recibo
                if (typeof next_element !== 'undefined') { // si el elemento siguiente no es indefinido
                    if (next_element.hasOwnProperty('num_fac_ter')) {
                        //element.accBalance = next_element.accBalance + element.importeBalance;
                        next_element.accBalance = element.accBalance + next_element.importeBalance
                    } else if (next_element.hasOwnProperty('id_pago')) {
                        //element.accBalance = next_element.accBalance + element.importeBalance;
                        next_element.accBalance = element.accBalance - next_element.importe;
                    } else if (next_element.hasOwnProperty('id_recibo')) {
                        next_element.accBalance = element.accBalance - (parseInt(next_element.total));
                    } else if (next_element.hasOwnProperty('id_anticipo')) {
                        next_element.accBalance = element.accBalance - next_element.valor;
                    }
                }
            } else if (element.hasOwnProperty('id_anticipo')) { // si es un anticipo pagado por un tercero
                if (typeof next_element !== 'undefined') { // si el elemento siguiente no es indefinido
                    if (next_element.hasOwnProperty('num_fac_ter')) {
                        //element.accBalance = next_element.accBalance + element.importeBalance;
                        //next_element.accBalance = element.accBalance < next_element.importeBalance ? next_element.importeBalance - element.accBalance : element.accBalance - next_element.importeBalance ;
                        next_element.accBalance = element.accBalance + next_element.importeBalance;
                    } else if (next_element.hasOwnProperty('id_pago')) {
                        //element.accBalance = next_element.accBalance + element.importeBalance;
                        next_element.accBalance = element.accBalance - next_element.importe;
                    } else if (next_element.hasOwnProperty('id_recibo')) {
                        next_element.accBalance = element.accBalance - (parseInt(next_element.total));
                    } else if (next_element.hasOwnProperty('id_anticipo')) {
                        next_element.accBalance = element.accBalance - next_element.valor;
                    }
                }
            }
        }
        setBalanceData(organizedArray);
        if (organizedArray.length) {
            setDatesStatusAccount({ ...datesStatusAccount, startDate: organizedArray[0].fechaToFilter, endDate: organizedArray[organizedArray.length - 1].fechaToFilter });
            calculateBalanceValues(organizedArray);
        }
        setLoadBalance(false);
    }


    //discrimina los pagos de las retenciones
    const filterPayments = (allPaymentsPlusRetentions) => {
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== true);
            return resul;
        }

    }
    //discrimina los pagos de las retenciones
    const filterRetentions = (allPaymentsPlusRetentions) => {
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== false);
            return resul;
        }

    }

    const organizeInvoices = invoices => {
        const size = invoices.length;
        let j, temp;

        for (let i = 1; i < size; i++) {
            j = i;
            temp = invoices[i];
            while (j > 0 && moment(invoices[j - 1].fechaToFilter).isAfter(temp.fechaToFilter)) {
                invoices[j] = invoices[j - 1];
                j--;
            }
            invoices[j] = temp;
        }
        return invoices;
    };

    //filtra las facturas cuando son de un particular
    const filterParticularInvoices = (wholeInvoice) => {
        let invoicesRemoveDuplicates = removeDuplicates(wholeInvoice, 'id_factura_t');
        let invoices = invoicesRemoveDuplicates.filter((invoice) => invoice.tipo === 1);
        setInvoicesData(invoices);
        let allAbonos = invoices.reduce((prev, current) => prev += parseInt(current.total), 0);
        setAbonosFromPatient(allAbonos);
        organizeDataToShowBalance(invoices);
    }

    const calculateTotal = (invoice) => {
        let total_tercero = 0;
        let total_abonos = 0;
        if (invoice.hasOwnProperty('servicios')) { //Factura en salud
            if (invoice.servicios !== null && invoice.servicios !== undefined) {
                if (invoice.tipo !== null) {
                    if (invoice.tipo === 1) { // cuando es particular el total de la factura es el total del copago
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.total)
                                total_abonos = 0;
                            })
                        }
                    } else { // cuando es otro regimen 
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.valor_tercero)
                                total_abonos += parseInt(recibo.total);
                            })
                        }
                    }
                }
            } else if (invoice.hasOwnProperty('detalles_comerciales')) { //Factura Comercial
                total_tercero = parseInt(invoice.detalles_comerciales?.total);
                total_abonos = parseInt(invoice.detalles_comerciales?.copago);
            } else {
                total_tercero = 0;
                total_abonos = 0;
            }
        }
        //setTotalInvoice(total_tercero);
        return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos }
        //return total_tercero;
    }

    const sumPayments = (payments) => {
        let totalPayments = 0
        if (payments !== null && payments !== undefined) {
            if (payments.length > 0) {
                payments.forEach((pay) => totalPayments += pay.importe)
            }
        }
        return totalPayments
    }

    const calculateBalanceValues = (balance) => {
        let totalBalance = 0;
        let totalBalancePayment = 0;
        let sumRetentions = 0;
        let sumAbonos = 0
        let calculateRetentions = [];
        if (allRetentionsRange !== null) {
            allRetentionsRange.forEach((ret) => {
                if (moment(ret.fechaToFilter).isBetween(moment(datesStatusAccount.startDate), moment(datesStatusAccount.endDate), 'second')) {
                    calculateRetentions.push(ret);
                }
            })
            sumRetentions = sumPayments(calculateRetentions);
            console.log("sumREtentions", sumRetentions, "ret", calculateRetentions);
        }
        balance.forEach((itemBalance) => {
            if (itemBalance.hasOwnProperty('num_fac_ter')) {
                let abonoByInvoice = calculateTotal(itemBalance);
                sumAbonos += abonoByInvoice.total_abonos;
                totalBalance += itemBalance.importeBalance;
            } else if (itemBalance.hasOwnProperty('id_pago')) {
                totalBalancePayment += itemBalance.importe;
            }
        });

        setMountTotalStatusAccount(prevState => { return { ...prevState, totalInvoices: totalBalance, totalPagos: totalBalancePayment, totalRetenciones: sumRetentions, totalAbonos: sumAbonos } })
    }

    const loadReceiptById = (id_recibo) => {
        return new Promise((resolve, reject) => {
            var data = { id_recibo: id_recibo };
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-por-id', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log('response', data)
                    if (data.existe) {
                        resolve(data.contenido[0]);
                    } else {
                        resolve(null);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })
    }

    const loadThird = (id_tercero) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/ver/' + id_tercero, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log('response', data)
                    if (data.existe) {
                        resolve(data.contenido[0]);
                    } else {
                        resolve(null);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })
    }

    const loadReceipstFromPatient = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-por-paciente-particular?id_historia=' + id_historia, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (typeof data !== '[]') {
                        resolve(data);
                        //setReceipts(data);
                    } else {
                        resolve(null)
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })
    }

    const showInvoiceSettlement = (invoice) => {
        if (invoice.radicacion !== null && invoice.radicacion !== undefined) {
            setInvoiceSettlement(invoice.radicacion);
            setDisplayInvoiceSettlement(true);
        } else {
            setInvoiceSettlement(null);
        }
    }

    const reactTableDataInvoicesByPatient = {
        tableHeaderData: [{
            Header: 'FACTURA No.',
            accessor: 'num_fac_ter',
            //disableGlobalFilter: true,
            width: 65,
        },
        {
            Header: 'FECHA DE EMISIÓN',
            accessor: 'fecha_emision',
            Cell: row => (
                <label>{moment(row.value).format('DD-MM-YYYY')}</label>
            )
        },
        {
            Header: 'FECHA DE VENCIMIENTO',
            accessor: 'vencimiento',
            Cell: row => (
                <label>{moment(row.value).format('DD-MM-YYYY')}</label>
            )
        },
        {
            Header: 'DÍAS VENCIDOS',
            accessor: 'dias_retraso_pago',
            Cell: row => (
                <label>{row.value}</label>
            )
        },
        {
            Header: 'ESTADO',
            accessor: 'estado_pago',
            Cell: row => (
                <label style={{ color: colorStateInvoice(row.value) }}>{stateInvoice(row.value)}</label>
            )
        },
        {
            Header: 'TOTAL',
            accessor: 'total',
            Cell: row => (
                <label>${formatNumber(defineValuesTotalInvoiceFromAbonos(row.row.original, false))}</label>
            )
        },
        {
            Header: 'PAGADO',
            Cell: row => (
                <label>${formatNumber(sumPayments(row.row.original.pagos))}</label>
            )
        },
        {
            Header: 'PENDIENTE',
            Cell: row => (
                <label>${formatNumber(defineValuesTotalInvoiceFromAbonos(row.row.original, false) - sumPayments(row.row.original.pagos))}</label>
            )
        },
        ],
        tableRowsData: invoicesData
    };

    const searchNameInvoice = (id_factura_t) => {
        let nameInvoice = '';
        if (invoicesData !== null) {
            let invoice = invoicesData.find((invoice) => invoice.id_factura_t === id_factura_t)
            nameInvoice = invoice.num_fac_ter;
        }

        return nameInvoice
    }

    const defineValuesTotalInvoiceFromAbonos = (infoInvoice, plusAbonos, soloAbonos) => {
        let valuesInvoice = calculateTotal(infoInvoice);
        if (plusAbonos) {
            return valuesInvoice.total_tercero + valuesInvoice.total_abonos
        } else if (soloAbonos) {
            return valuesInvoice.total_abonos;
        } else {
            return valuesInvoice.total_tercero;
        }

    }

    const reactTableDataBalance = {
        tableHeaderData: [{
            Header: 'FECHA',
            accessor: 'fechaToFilter',
            //disableGlobalFilter: true,
            width: 65,
            Cell: row => (
                <label>{moment(row.value).format("DD-MM-YYYY")}</label>
            )
        },
        {
            Header: 'DETALLES',
            accessor: 'detalle',
            Cell: row => (
                <label>{row.row.original.hasOwnProperty('num_fac_ter') ?
                    <Fragment>
                        <p>Factura: <b>{row.row.original.num_fac_ter}</b></p>
                        <p style={{ marginTop: 0 }}>vence el {moment(row.row.original.vencimiento).format('DD-MM-YYYY')}</p>
                    </Fragment>
                    : row.row.original.hasOwnProperty('id_pago') ?
                        <Fragment>
                            <p>Pago: No. <b>{row.row.original.id_pago}</b></p>
                            <p style={{ marginTop: 0 }}>para la factura <b>{searchNameInvoice(row.row.original.id_factura_t)}</b></p>
                        </Fragment>
                        : row.row.original.hasOwnProperty('id_recibo') ?
                            <Fragment>
                                <p>Abono hecho en recibo No. <b>{row.row.original.num_recibo}</b></p>
                                <p style={{ marginTop: 0 }}>Tipo de abono: <b>{row.row.original.tipo_pago}</b></p>
                            </Fragment>
                            : null
                }</label>
            )
        },
        {
            Header: 'VALOR FAC.',
            Cell: row => (
                <label>{row.row.original.hasOwnProperty('num_fac_ter') ?
                    <Fragment>
                        <p><b>${formatNumber(defineValuesTotalInvoiceFromAbonos(row.row.original, false))}</b></p>
                    </Fragment>
                    : null
                }</label>
            )
        },
        {
            Header: 'PAGOS',
            Cell: row => (
                <label>{row.row.original.hasOwnProperty('id_pago') ?
                    <Fragment>
                        <p><b>${formatNumber(row.row.original.importe)}</b></p>
                    </Fragment>
                    : row.row.original.hasOwnProperty('id_recibo') ?
                        <Fragment>
                            <p><b>${formatNumber(parseInt(row.row.original.total))}</b></p>
                        </Fragment>
                        : null
                }</label>
            )
        },
        {
            Header: 'BALANCE', //importeBalance
            accessor: 'accBalance',
            Cell: row => (
                <label style={{ color: changeColor(row.row.original.accBalance) }}>${formatNumber(row.row.original.accBalance < 0 ? '+' + Math.abs(row.row.original.accBalance) : row.row.original.accBalance)}</label>
            )
        }
        ],
        tableRowsData: balanceModifiedByRange !== null ? balanceModifiedByRange : balanceData
    };

    const searchReceiptDetails = async (receipts) => {
        setLoadReceipts(true);
        skipPageResetRef.current = true;
        console.log("recibos", receipts)
        let receiptsByInvoice = []
        if (receipts !== null && receipts !== undefined) {
            if (receipts.length > 0) {
                for (let i = 0; i < receipts.length; i++) {
                    const receipt = receipts[i];
                    let searchReceipt = await loadReceiptById(receipt.id);
                    if (searchReceipt !== null) {
                        receiptsByInvoice.push(searchReceipt);
                    }
                }
            }
        }
        if (receiptsByInvoice.length === 0) {
            setReceiptsByInvoice(null);
        } else {
            setReceiptsByInvoice(receiptsByInvoice)
        }
        setLoadReceipts(false);
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const changeColor = (total) => {
        let color = '#232329';
        if (total < 0) {
            color = '#04D546'
        }
        return color;
    }

    //Informacion del tercero
    const reactTableDataBalanceClient = {
        tableHeaderData: [{
            Header: 'FECHA',
            accessor: 'fechaToFilter',
            //disableGlobalFilter: true,
            width: 65,
            Cell: row => (
                <label>{moment(row.value).format("DD-MM-YYYY")}</label>
            )
        },
        {
            Header: 'DETALLES',
            accessor: 'detalle',
            Cell: row => (
                <div>{row.row.original.hasOwnProperty('num_fac_ter') ?
                    <Fragment>
                        <Accordion expanded={expanded === `panel${row.row.original.detalle}`} onChange={handleChange(`panel${row.row.original.detalle}`)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                onClick={() => searchReceiptDetails(row.row.original.servicios.recibos_caja)}
                                aria-controls={`panel${row.row.original.num_fac_ter}-content`}
                                id={`panel${row.row.original.num_fac_ter}-header`}
                            >
                                <div>
                                    <p>Factura: <b>{row.row.original.num_fac_ter}</b></p>
                                    <p style={{ marginTop: 0 }}>vence el {moment(row.row.original.vencimiento).format('DD-MM-YYYY')}</p>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='show-receipts-into-table'>
                                    <h5>Recibos:</h5>
                                    {
                                        loadReceipts ?
                                            <div className="text-center">
                                                <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                            </div>
                                            :
                                            receiptsByInvoice &&
                                            <div className='receipt-details'>
                                                <h4><b>{receiptsByInvoice[0].num_recibo}</b></h4>
                                                <p>Tipo de Abono: <b>{receiptsByInvoice[0].tipo_pago}</b></p>
                                                <p><b>Valor: ${formatNumber(parseInt(receiptsByInvoice[0].total))}</b></p>
                                                <hr />
                                                {receiptsByInvoice.length > 1 ?
                                                    <label style={{ cursor: 'pointer', color: '#0084CF', textDecoration: 'underline' }} onClick={() => setShowModalDetails(!showModalDetails)}>
                                                        Ver más
                                                    </label>
                                                    : null}
                                            </div>
                                    }

                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </Fragment>
                    : row.row.original.hasOwnProperty('id_pago') ?
                        <Fragment>
                            <p>Pago: No. <b>{row.row.original.id_pago}</b></p>
                            <p style={{ marginTop: 0 }}>para la factura <b>{searchNameInvoice(row.row.original.id_factura_t)}</b></p>
                        </Fragment>
                        : row.row.original.hasOwnProperty('id_recibo') ?
                            <Fragment>
                                <p>Abono hecho en recibo No. <b>{row.row.original.num_recibo}</b></p>
                                <p style={{ marginTop: 0 }}>Tipo de abono: <b>{row.row.original.tipo_pago}</b></p>
                            </Fragment>
                            : row.row.original.hasOwnProperty('id_anticipo') ?
                                <Fragment>
                                    <p>Anticipo No. <b>{row.row.original.id_anticipo}</b></p>
                                    <p style={{ marginTop: 0 }}>Concepto: <b>{row.row.original.concepto}</b></p>
                                </Fragment>
                                : null
                }</div>
            )
        },
        {
            Header: 'VALOR FAC.',
            Cell: row => (
                <label>{row.row.original.hasOwnProperty('num_fac_ter') ?
                    <Fragment>
                        <p><b>${formatNumber(defineValuesTotalInvoiceFromAbonos(row.row.original, true, false))}</b></p>
                    </Fragment>
                    : null
                }</label>
            )
        },
        {
            Header: 'PAGOS',
            Cell: row => (
                <label>{row.row.original.hasOwnProperty('id_pago') ?
                    <Fragment>
                        <p><b>${formatNumber(row.row.original.importe)}</b></p>
                    </Fragment>
                    : row.row.original.hasOwnProperty('id_anticipo') ?
                        <Fragment>
                            <p><b>${formatNumber(row.row.original.valor)}</b></p>
                        </Fragment>
                        : null
                }</label>
            )
        },
        {
            Header: 'ABONOS',
            Cell: row => (
                <label>{row.row.original.hasOwnProperty('num_fac_ter') ?
                    <Fragment>
                        <p><b>${formatNumber(defineValuesTotalInvoiceFromAbonos(row.row.original, false, true))}</b></p>
                    </Fragment>
                    : null
                }</label>
            )
        },
        {
            Header: 'BALANCE', //importeBalance
            accessor: 'accBalance',
            Cell: row => (
                <label style={{ color: changeColor(row.row.original.accBalance) }}>${formatNumber(row.row.original.accBalance < 0 ? '+' + Math.abs(row.row.original.accBalance) : row.row.original.accBalance)}</label>
            )
        }
        ],
        tableRowsData: balanceModifiedByRange !== null ? balanceModifiedByRange : balanceData
    };


    const LoadInfo = () => {
        return (<DataReactTableAccountStatus
            reactTableData={reactTableDataInvoicesByPatient}
            refresh={id_tercero !== null && id_tercero !== undefined ? checkInvoicesThird : checkInvoicesPatient}
            showInvoiceSettlement={showInvoiceSettlement}
        /* getPaymentById={getPaymentById}
        invoiceToEdit={invoiceToEdit} */
        />)
    }

    const BalanceTable = () => {
        return (
            <DataReactTableBalanceAccount
                reactTableData={profileType === 'patient' ? reactTableDataBalance : reactTableDataBalanceClient}
                autoResetPage={!skipPageResetRef.current} />
        )
    }

    const openStatusAccountPdf = async () => {
        let clientThrid, clientPacient;
        if (id_tercero !== null && id_tercero !== undefined) {
            clientThrid = await loadThird(id_tercero);
        } else if (dataPatient !== null && dataPatient !== undefined) {
            clientPacient = dataPatient
        } else {
            clientThrid = null;
            clientPacient = null;
        }
        const data = {
            clientThrid: clientThrid,
            clientPacient: clientPacient,
            allInvoiceFromProfileSearched: invoicesData,
            startDate: datesStatusAccount.startDate,
            endDate: datesStatusAccount.endDate,
            infoStatusAccount: createReportByCostum ? balanceModifiedByRange : balanceData,
            profile: profile,
            urlLogo: urlLogo,
            mountTotalStatusAccount: mountTotalStatusAccount
        }
        setShowStatusAccountPdf(true);
        pdfStatusAccount(data);
    }


    const setNewRange = () => {
        skipPageResetRef.current = true;
        setLoadBalance(true);
        let newBalance;
        let searchstartIndexTwo = 0;
        let searchEndIndexTwo = 0;
        let indexesStart = [];
        let indexesEnd = [];
        balanceData.forEach((balance, index) => {
            if (moment(datesStatusAccount.startDate).isSameOrBefore(moment(balance.fechaToFilter), 'day')) {
                console.log(balance, index);
                indexesStart.push(index);
            }
        })
        searchstartIndexTwo = indexesStart[0];

        balanceData.forEach((balance, index) => {
            if (moment(datesStatusAccount.endDate).isSameOrAfter(moment(balance.fechaToFilter), 'day')) {
                console.log(balance, index);
                indexesEnd.push(index);
            }
        })
        searchEndIndexTwo = indexesEnd[indexesEnd.length - 1];
        console.log("STARTINDEX", searchstartIndexTwo, "ENDINDEX", searchEndIndexTwo)

        newBalance = balanceData.slice(searchstartIndexTwo, searchEndIndexTwo + 1);
        setBalanceModifiedByRange(newBalance);
        calculateBalanceValues(newBalance);

        let newSelectedInvoices = invoicesData.slice(searchstartIndexTwo, searchEndIndexTwo + 1);
        setRecalculateBalanceValuesByRangeSelected(newSelectedInvoices);
        setLoadBalance(false);

    }


    const showInLetterReceiptsState = (state_receipt, canceledReceipt) => {
        let receipts_state = '';
        if (state_receipt === 1 && canceledReceipt !== true) {
            receipts_state = 'ACTIVO'
        } else if (state_receipt === 2 && canceledReceipt !== true) {
            receipts_state = 'FACTURADO'
        } else {
            receipts_state = 'ANULADO'
        }
        return receipts_state;
    }

    const calculateSubtotalReceipt = (copago, total) => {
        try {
            let subtotal = parseInt(copago) + parseInt(total);
            return subtotal;
        }
        catch (err) {
            console.log(err);
        }
    }

    const reactTableDataReceipts = {
        tableHeaderData: [{
            Header: 'ID',
            accessor: 'id_recibo',
            //disableGlobalFilter: true,
        },
        {
            Header: 'RECIBO NRO.',
            accessor: 'num_recibo',
            Cell: row => (
                <div>
                    {
                        row.value != null && row.value ?
                            <label>
                                {row.value}
                            </label>
                            : "N/a"
                    }
                </div>
            )
        },
        {
            Header: 'ESTADO',
            accessor: 'estado', /* 1. PENDIENTE, 2. FACTURADO 3.RECHAZADO O CANCELADO */
            Cell: row => (
                <label>{showInLetterReceiptsState(row.cell.row.original.estado, row.cell.row.original.recibo_cancelado)}</label>
            )
        },
        {
            Header: 'FORMA DE PAGO',
            accessor: 'forma_pago',
        },
        {
            Header: 'SUBTOTAL',
            Cell: row => (
                <label>${formatNumber(calculateSubtotalReceipt(row.cell.row.original.total, row.cell.row.original.valor_tercero))}</label>
            )
        },
        {
            Header: "ABONO",
            accessor: 'total',
            Cell: row => (
                <label>${formatNumber(parseInt(row.value))}</label>
            )
        },
        {
            Header: "Total",
            accessor: 'valor_tercero',
            Cell: row => (
                <label>${formatNumber(parseInt(row.value))}</label>
            )
        },
        ],
        tableRowsData: receiptsByInvoice
    };

    const LoadInfoReceipts = () => {
        return (<DataReactTableReceiptsThird
            reactTableData={reactTableDataReceipts}
        />)
    }

    return (
        <Fragment>
            <Col md={12} lg={12}>
                <Card>
                    <CardBody>
                        {invoicesData &&
                            <Row>
                                <SummaryInfoStatusAccount invoicesData={/* recalculateBalanceValuesByRangeSelected !== null ? recalculateBalanceValuesByRangeSelected :  */invoicesData} abonosFromPatient={abonosFromPatient} setMountTotalStatusAccount={setMountTotalStatusAccount} advancedPayments={advancedPayments} profileType={profileType} />
                            </Row>
                        }
                        {
                            displayInvoiceSettlement ?
                                invoiceSettlement !== null && invoiceSettlement !== undefined ?
                                    invoiceSettlement.length !== 0 ?
                                        <Row>
                                            <div className='show-settlement-group'>
                                                <ShowSettlementCard settlement={invoiceSettlement} />
                                            </div>
                                        </Row>
                                        :
                                        <div className='no-settlement-info'>
                                            <h5>No se ha generado aún ninguna Radicación a esta Factura</h5>
                                        </div>
                                    :
                                    <div className='no-settlement-info'>
                                        <h5>No se ha generado aún ninguna Radicación a esta Factura</h5>
                                    </div>
                                : null
                        }
                        {
                            loadBalance ?
                                <div className="text-center">
                                    <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                </div>
                                : /* invoicesData ?
                                    <LoadInfo /> */

                                balanceData && balanceModifiedByRange ?
                                    <Fragment>
                                        <div className='top-action-buttons-status-account'>
                                            <div className='unit-buttons'>
                                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                                    <ThemeProvider theme={defaultMaterialTheme}>
                                                        <KeyboardDatePicker
                                                            //disableFuture
                                                            minDate={balanceData[0].fechaToFilter}
                                                            maxDate={datesStatusAccount.endDate !== null ? moment(datesStatusAccount.endDate).subtract(1, 'd') : balanceData[balanceData.length - 1].fechaToFilter}
                                                            //maxDate={balanceData[balanceData.length - 1].fechaToFilter}
                                                            label="Fecha de Inicio"
                                                            value={datesStatusAccount.startDate}
                                                            onChange={(date) => {
                                                                if (date !== null) {
                                                                    if (date._isValid) {
                                                                        setDatesStatusAccount({ ...datesStatusAccount, startDate: new Date(date) });
                                                                        setCreateReportByCostum(true);
                                                                        //setAnotherRangeToGetStatusAccountStart(new Date(date));
                                                                        //setNewRange();
                                                                    }
                                                                }
                                                            }}
                                                            animateYearScrolling
                                                            format="DD/MM/YYYY"
                                                            autoOk={true}
                                                            style={{ width: '100%' }}
                                                        />
                                                    </ThemeProvider>
                                                </MuiPickersUtilsProvider>
                                            </div>
                                            <div className='unit-buttons'>
                                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                                    <ThemeProvider theme={defaultMaterialTheme}>
                                                        <KeyboardDatePicker
                                                            //disableFuture
                                                            //minDate={balanceData[0].fechaToFilter}
                                                            minDate={datesStatusAccount.startDate !== null ? moment(datesStatusAccount.startDate).add(1, 'd') : balanceData[0].fechaToFilter}
                                                            maxDate={balanceData[balanceData.length - 1].fechaToFilter}
                                                            label="Fecha Final"
                                                            value={datesStatusAccount.endDate}
                                                            onChange={(date, event) => {
                                                                if (date !== null) {
                                                                    if (date._isValid) {
                                                                        setDatesStatusAccount({ ...datesStatusAccount, endDate: new Date(date) });
                                                                        setCreateReportByCostum(true);
                                                                        //setAnotherRangeToGetStatusAccountEnd(new Date(date));
                                                                        //setNewRange();
                                                                    }
                                                                }
                                                            }}
                                                            animateYearScrolling
                                                            format="DD/MM/YYYY"
                                                            autoOk={true}
                                                            style={{ width: '100%' }}
                                                        />
                                                    </ThemeProvider>
                                                </MuiPickersUtilsProvider>
                                            </div>
                                            <div className='unit-buttons'>
                                                <Tooltip title="Visualizar estado de cuenta completo">
                                                    <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb', width: '1.5em', height: '1.5em' }}
                                                        disabled={balanceData !== null && balanceData !== undefined ? false : true}
                                                        onClick={() => {
                                                            openStatusAccountPdf();
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faFilePdf} style={{ color: '#153365', width: '1em', height: '1em' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <BalanceTable />
                                        <div className='info-summary-status-account'>
                                            <div className='summary-data'>
                                                <div className='line-info'>
                                                    <div><h4>Comenzando balance: </h4></div>
                                                    <div><h4>{formatNumber(balanceModifiedByRange !== null ?
                                                        balanceModifiedByRange[0].hasOwnProperty('num_fac_ter') ? '$' + balanceModifiedByRange[0].accBalance
                                                            : balanceModifiedByRange[0].accBalance < 0 ? '+' + Math.abs(balanceModifiedByRange[0].accBalance)
                                                                : balanceModifiedByRange[0].accBalance
                                                        : balanceData[0].hasOwnProperty('num_fac_ter') ? '$' + balanceData[0].accBalance
                                                            : balanceData[0].accBalance < 0 ? '+' + Math.abs(balanceData[0].accBalance)
                                                                : balanceData[0].accBalance)}</h4></div>
                                                </div>
                                                <div className='line-info'>
                                                    <div><h4>Total facturado: </h4></div>
                                                    <div><h4>${formatNumber(mountTotalStatusAccount?.totalInvoices)}</h4></div>
                                                </div>
                                                {
                                                    profileType !== 'patient' ?
                                                        <Fragment>
                                                            <div className='line-info'>
                                                                <div><h4>Total Abonos: </h4></div>
                                                                <div><h4>${formatNumber(mountTotalStatusAccount?.totalAbonos)}</h4></div>
                                                            </div>
                                                        </Fragment>
                                                        :
                                                        <div className='line-info'>
                                                            <div><h4>Total pagado: </h4></div>
                                                            <div><h4>${formatNumber(abonosFromPatient)}</h4></div>
                                                        </div>
                                                }
                                                <div className='line-info'>
                                                    <div><h4>Total retenciones: </h4></div>
                                                    <div><h4>${formatNumber(mountTotalStatusAccount?.totalRetenciones)}</h4></div>
                                                </div>
                                                <div className='line-info'>
                                                    <div> <h4><b>Balance vencido: </b></h4></div>
                                                    <div> <h4>${formatNumber(
                                                        balanceModifiedByRange[balanceModifiedByRange.length - 1] !== undefined ?
                                                            balanceModifiedByRange[balanceModifiedByRange.length - 1].accBalance - mountTotalStatusAccount?.totalRetenciones >= 0 ?
                                                                balanceModifiedByRange[balanceModifiedByRange.length - 1].accBalance - mountTotalStatusAccount?.totalRetenciones
                                                                : '0' : '')}</h4></div>
                                                </div>
                                            </div>

                                        </div>
                                    </Fragment>
                                    :
                                    <div className='info-empty-profile'>
                                        <h5>No hay datos suficientes para generar el balance</h5>
                                    </div>
                        }
                    </CardBody>
                </Card>
            </Col>
            {showStatusAccountPdf ?
                <Modal
                    open={showStatusAccountPdf}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '80%', margin: 10, height: '80%' }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowStatusAccountPdf(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <iframe id="pdfV" width="100%" height="90%" title="pdf-report" >
                        </iframe>
                    </div>
                </Modal>
                : null}
            {showModalDetails ?
                <Modal
                    open={showModalDetails}
                    onClose={() => {
                        setShowModalDetails(false);
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '80%', margin: 10 }}>
                        {receiptsByInvoice &&
                            <div className='modal-receipts'>
                                <h4>Recibos</h4>
                                <LoadInfoReceipts />
                            </div>
                        }
                    </div>
                </Modal>
                : null}
        </Fragment>
    )
}

export default ProfileAccountStatus